import React, { useRef, useEffect, useState } from 'react';
import { getKvizPitanje } from '../../../server/server-kviz';
import { FaQuestion } from 'react-icons/fa';
import MDEditor from '@uiw/react-md-editor';
import { mathPlugins } from '../../../utils/markdownMath';
import { TezinaPitanja } from '../../../model/enum/tezina-pitanja.enum';
import KvizPitanjeConnect from '../../obrazovanje/pitanje/KvizPitanjeConnect';
import { Oval } from 'react-loader-spinner';
import { playCorrectAnswerSound, playWrongAnswerSound } from '../../utils/util';
import { TrajanjeDuzinePitanja } from '../LovacKvizHome';
import { useUser } from '../../../auth/UseUser';
import { kvizList } from '../KvizHome';
import AnswerMarkdown from '../../common/AnswerMarkdown';

const KVIZ_LENGTH = 4;

const TezinaSelectedList = [
    { title: 'Lako', value: TezinaPitanja.LAKO, color: '#a5d6a7', borderColor: '#1b5e20', lighColor: '#c8e6c9' },
    { title: 'Srednje', value: TezinaPitanja.SREDNJE, color: '#ce93d8', borderColor: '#4a148c', lighColor: '#e1bee7' },
    { title: 'Teško', value: TezinaPitanja.TESKO, color: '#e57373', borderColor: '#b71c1c', lighColor: '#ffcdd2' },
    { title: 'Napredno', value: TezinaPitanja.NAPREDNO, color: '#ffb74d', borderColor: '#e65100', lighColor: '#ffe0b2' },
    { title: 'Mešano', value: -1, color: '#90caf9', borderColor: '#0d47a1', lighColor: '#bbdefb' },
];

function KlasikKvizHome() {
    const { setReturnedList } = useUser();
    const [pitanja, setPitanja] = useState<any[]>([]);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [markedAnswers, setMarkedAnswers] = useState<any[]>([]);
    const timer = useRef<any>(null);
    const progressBar = useRef<any>(null);
    const [brojTacnihOdgovora, setBrojTacnihOdgovora] = useState(0);
    const [mode, setMode] = useState('start');
    const [selectedTezina, setSelectedTezina] = useState(-1);
    const [loadingKvizPitanje, setLoadingKvizPitanje] = useState(false);
    const isActiveRef = useRef(true);

    // prati da li je komponenta i dalje na ekranu (napuštanje stranice = unmount)
    useEffect(() => {
        isActiveRef.current = true;
        return () => {
            isActiveRef.current = false;
        };
    }, []);

    const loadPitanje = async () => {
        setLoadingKvizPitanje(true);
        const resp = await getKvizPitanje({ tezina: selectedTezina !== -1 ? selectedTezina.toString() : '' });
        if (!isActiveRef.current) return; // korisnik je u međuvremenu napustio kviz
        if (resp.status === 201) {
            setPitanja([...pitanja, resp.data]);
            console.log('lista pitanja ', [...pitanja, resp.data]);
            setLoadingKvizPitanje(false);
        } else {
            console.log('error', resp.data);
            setLoadingKvizPitanje(false);
        }
    };

    const exitKviz = () => {
        setCurrentQuestionIndex(0);
        setPitanja([]);
        setMarkedAnswers([]);
        setBrojTacnihOdgovora(0);
        setMode('start');
        if (timer.current) {
            clearTimeout(timer.current);
        }
    };

    const finishKviz = () => {
        setTimeout(() => {
            setMode('rezultat');
        }, 1500);
    };
    const startKviz = () => {
        setMode('test');
    };

    const setAnswer = (answer: any) => {
        if (progressBar.current) progressBar.current.classList.remove('active');
        if (answer?.tacan) {
            setBrojTacnihOdgovora((prev: number) => prev + 1);
            playCorrectAnswerSound();
        } else {
            playWrongAnswerSound();
        }
        setMarkedAnswers([...markedAnswers, answer]);
        console.log('lista odgovora ', [...markedAnswers, answer]);
        if (currentQuestionIndex + 1 < KVIZ_LENGTH) {
            setTimeout(() => {
                setCurrentQuestionIndex(currentQuestionIndex + 1);
            }, 1500);
        } else if (currentQuestionIndex + 1 === KVIZ_LENGTH) {
            if (timer.current) {
                clearTimeout(timer.current);
            }
            finishKviz();
        }
    };

    const gotoNextQuestion = () => {
        if (!isActiveRef.current) return; // korisnik je u međuvremenu napustio kviz
        console.log('go to next question', currentQuestionIndex, KVIZ_LENGTH);
        setMarkedAnswers([...markedAnswers, {}]);
        playWrongAnswerSound();
        if (timer.current) {
            clearTimeout(timer.current);
        }
        if (currentQuestionIndex + 1 < KVIZ_LENGTH) {
            if (progressBar.current) progressBar.current.classList.remove('active');
            setTimeout(() => {
                setCurrentQuestionIndex(currentQuestionIndex + 1);
            }, 1500);
            console.log('go to next question 1. if');
            console.log('lista odgovora ', [...markedAnswers, {}]);
        } else if (currentQuestionIndex + 1 === KVIZ_LENGTH) {
            if (progressBar.current) progressBar.current.classList.remove('active');
            finishKviz();
            console.log('go to next question 2. if');
            console.log('lista odgovora ', [...markedAnswers, {}]);
        }
    };

    useEffect(() => {
        if (timer.current) {
            clearTimeout(timer.current);
        }

        const fetchData = async () => {
            if (mode === 'test') {
                await loadPitanje(); // Čeka da se loadPitanje završi
                if (!isActiveRef.current) return; // korisnik je u međuvremenu napustio kviz

                setTimeout(() => {
                    if (progressBar.current) progressBar.current.classList.add('active');
                }, 100);

                timer.current = setTimeout(gotoNextQuestion, TrajanjeDuzinePitanja * 1000);
            }
        };

        fetchData();
        return () => {
            if (timer.current) {
                clearTimeout(timer.current);
            }
        };
    }, [mode, currentQuestionIndex]);

    useEffect(() => {
        setReturnedList(kvizList);
    }, []);

    return (
        <div className="flex h-full flex-col items-center bg-blueDark pt-5">
            <div className={`flex w-full h-full flex-col items-center overflow-y-auto no-scroll   py-[20px]`}>
                <div className=" w-full h-full max-w-[1100px] px-[10px]">
                    {mode === 'start' && (
                        <div className="w-full min-h-full  bg-white flex flex-col py-[30px] rounded-[10px]">
                            <div className="grid grid-cols-10 gap-4">
                                <div className="col-span-9 bg-greyMedium rounded-r-full p-3 flex flex-row items-center justify-between">
                                    <p className="lekcija-naziv">Klasičan kviz</p>
                                    <button onClick={() => startKviz()} className="start-button">
                                        Pokreni kviz
                                    </button>
                                </div>
                            </div>
                            <div className="mt-7">
                                <p className="text-blueMedium text-[36px] leading-10 font-bold text-center " style={{ fontFamily: 'RubikDoodleShadow' }}>
                                    Odaberite nivo težine pitanja
                                </p>
                            </div>
                            <div className="w-full flex flex-col items-center gap-[14px] mt-7">
                                {TezinaSelectedList.map((item: any, index: number) => (
                                    <button
                                        className=" w-[250px] max-w-[250px] min-h-[50px] flex flex-row items-center justify-center gap-5 px-6 rounded-[15px] transition border-[3px]"
                                        key={index}
                                        style={{
                                            backgroundColor: selectedTezina === item.value ? item.lighColor : item.color,
                                            borderColor: selectedTezina === item.value ? item.borderColor : item.color,
                                            transform: selectedTezina === item.value ? 'scale(1.15)' : 'scale(1)',
                                        }}
                                        onClick={() => setSelectedTezina(item.value)}
                                    >
                                        <p
                                            className={`text-grey-900 text-[36px] leading-[40px] font-bold text-center `}
                                            style={{ fontFamily: 'RubikDoodleShadow', color: item.borderColor }}
                                        >
                                            {item.title}
                                        </p>
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}
                    {mode === 'test' && (
                        <div className="w-full min-h-full  bg-white flex flex-col py-[30px] rounded-[10px]">
                            <div className="grid grid-cols-9 gap-4">
                                <div className="col-span-8  bg-greyMedium rounded-r-full p-3 flex flex-row items-center justify-between">
                                    <p className="lekcija-naziv">Klasičan kviz</p>
                                    <button onClick={() => exitKviz()} className="start-button">
                                        Prekini kviz
                                    </button>
                                </div>
                                <div className="col-span-9 md:col-span-1 flex  items-center justify-center">
                                    <p className="text-blueMedium text-[24px] leading-7 font-bold text-center ">
                                        {currentQuestionIndex + 1}/{KVIZ_LENGTH}
                                    </p>
                                </div>
                            </div>
                            {!loadingKvizPitanje ? (
                                <>
                                    <div className="mt-5 px-3 w-full">
                                        <div className="progress-container">
                                            <div
                                                className="progress-bar active"
                                                ref={progressBar}
                                                style={{ animationDuration: `${TrajanjeDuzinePitanja}s` }}
                                            ></div>
                                        </div>
                                    </div>
                                    <div className=" pb-5 px-3 md:px-20 w-full flex flex-col items-center">
                                        <div className="flex flex-row items-center gap-2 mt-5  w-full max-w-[450px] ">
                                            <div className="h-[60px] min-w-[60px] border border-blueMedium rounded-full justify-center items-center flex">
                                                <FaQuestion size={35} color="#234b98" />
                                            </div>

                                            <MDEditor.Markdown {...mathPlugins} className="test-znanja-naziv" source={pitanja[currentQuestionIndex]?.naziv} />
                                        </div>
                                        <div className="h-[1px] w-full max-w-[450px] bg-blueMedium mt-5"></div>
                                        <div className="w-full flex flex-col items-center gap-4 mt-6">
                                            {pitanja[currentQuestionIndex] &&
                                                pitanja[currentQuestionIndex]?.odgovori?.map((odgovor: any, index: number) => {
                                                    return (
                                                        <Odgovor
                                                            odgovor={odgovor}
                                                            handleOdgovor={setAnswer}
                                                            currentIndex={currentQuestionIndex}
                                                            datiOdgovori={markedAnswers}
                                                            key={odgovor?.id}
                                                        />
                                                    );
                                                })}
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <div className="w-full flex-1 flex items-center justify-center">
                                    <Oval />
                                </div>
                            )}
                        </div>
                    )}
                    {mode === 'rezultat' && (
                        <div className="w-full min-h-full  bg-grey-100 flex flex-col py-[30px] rounded-[10px]">
                            <div className="grid grid-cols-9 gap-5">
                                <div className="col-span-8 md:col-span-5 bg-greyMedium rounded-r-full p-3 flex flex-row items-center justify-between">
                                    <p className="lekcija-naziv ">Kviz je završen</p>
                                    <button onClick={exitKviz} className="start-button">
                                        Zatvori
                                    </button>
                                </div>

                                <div className="col-span-9 md:col-span-4 flex flex-row gap-3  items-center justify-center">
                                    <p className="text-greyMedium text-[20px] leading-6 font-bold">Vaša ocena je </p>
                                    <div className="h-[60px] min-w-[60px] border border-greyStrong rounded-full justify-center items-center flex shadow-xl">
                                        <p
                                            className="text-greyStrong text-[40px] leading-[48px] font-bold text-center "
                                            style={{ fontFamily: 'RubikDoodleShadow' }}
                                        >
                                            {Math.max(Math.round((brojTacnihOdgovora / KVIZ_LENGTH) * 5), 1)}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="pt-5 pb-11 px-3 md:px-20 ">
                                <p className="text-greyStrong text-[16px] leading-5 font-semibold">
                                    Ispod se nalaze rezultati testa znanja sa tačnim odgovorima i objašnjenjima
                                </p>
                                <div className="flex flex-col mt-5 gap-7">
                                    {pitanja.map((pitanje: any, index: number) => {
                                        return (
                                            <KvizPitanjeCard
                                                pitanje={pitanje}
                                                kvizPitanja={pitanja}
                                                datiOdgovori={markedAnswers}
                                                index={index}
                                                key={pitanje.id}
                                            />
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default KlasikKvizHome;

const KvizPitanjeCard = ({ pitanje, kvizPitanja, datiOdgovori, index }: { pitanje: any; kvizPitanja: any; datiOdgovori: any; index: number }) => {
    const getTacanOdgovor = () => {
        let tacanOdgovor = {};
        pitanje.odgovori.forEach((odgovor: any) => {
            if (odgovor?.tacan) tacanOdgovor = odgovor;
        });
        return tacanOdgovor;
    };

    const isCorrectAnswer = datiOdgovori[index].tacan;
    const tacanOdgovor: any = getTacanOdgovor();
    return (
        <div className={`rounded-[15px] pt-3 ${isCorrectAnswer ? 'bg-greenA200' : 'bg-redError'} shadow-xl`}>
            <p className="text-grey-900 text-[24px] leading-7 font-bold ml-10 " style={{ fontFamily: 'RubikDoodleShadow' }}>
                {index + 1}/{kvizPitanja.length}
            </p>
            <div className="bg-white flex flex-col gap-3 rounded-[15px] px-7 py-3 mt-2">
                <div className="flex flex-row gap-3">
                    <div className="h-[40px] min-w-[40px] border border-blueMedium rounded-full justify-center items-center flex">
                        <FaQuestion size={30} color="#234b98" />
                    </div>
                    <MDEditor.Markdown {...mathPlugins} className="test-znanja-naziv" source={pitanje?.naziv} />
                </div>
                <div className="flex flex-row gap-1">
                    <MDEditor.Markdown {...mathPlugins} className="test-znanja-odgovor" source={'<b>Tačan odgovor</b>: ' + tacanOdgovor?.text} />
                </div>
                <div className="flex flex-row gap-1">
                    {pitanje?.opis.trim() && <MDEditor.Markdown {...mathPlugins} className="test-znanja-opis" source={'<b>Opis</b>: ' + pitanje?.opis} />}
                </div>
            </div>
        </div>
    );
};

const Odgovor = ({ odgovor, handleOdgovor, currentIndex, datiOdgovori }: { odgovor: any; handleOdgovor: any; currentIndex: any; datiOdgovori: any }) => {
    const [selected, setSelected] = useState(false);
    const selectOdgovor = (odgovor: any) => {
        setSelected(true);
        handleOdgovor(odgovor);
    };

    useEffect(() => {
        setSelected(false);
    }, [odgovor]);

    return (
        <button
            className={` w-full max-w-[450px] min-h-[50px] ${
                !selected && currentIndex + 1 === datiOdgovori.length && odgovor?.tacan
                    ? 'bg-greenA200'
                    : !selected
                      ? 'bg-blueLight hover:bg-blueHoverLight'
                      : selected && odgovor?.tacan
                        ? 'bg-greenA200'
                        : 'bg-redError'
            } flex flex-row items-center gap-5 px-6 rounded-[15px] transition`}
            onClick={() => selectOdgovor(odgovor)}
            disabled={currentIndex + 1 === datiOdgovori.length}
        >
            <AnswerMarkdown source={odgovor.text} />
        </button>
    );
};

// <div className='bg-osnovnaPozadina w-full h-full '>
// 	<div className='h-full   overflow-auto '>
// 		<div className='flex flex-col items-center gap-5  py-5'>
// 			<div className='question bg-beeYellow w-[95%] max-w-[650px] min-h-[350px]'>
// 				<div className='progress-bar' ref={progressBar}></div>
// 				<div className='w-full flex flex-row items-center justify-center gap-1'>
// 					<p>{currentQuestionIndex + 1}</p> <p>od {pitanja.length} </p>
// 				</div>
// 				<p className='text-[16px] leading-5 text-greyStrong text-center'>{pitanja[currentQuestionIndex]?.naziv}</p>
// 				<div className='main'>
// 					<div className='grid grid-cols-1 sm:grid-cols-2 gap-3'>
// 						{pitanja[currentQuestionIndex]?.odgovori?.map((odgovor: any, index: number) => (
// 							<button className='w-full h-10 rounded-md bg-white flex flex-row items-center justify-center cursor-pointer' onClick={() => setAnswer(odgovor)}>
// 								{odgovor.text}
// 							</button>
// 						))}
// 					</div>
// 				</div>
// 				<div>
// 					<button
// 						onClick={() => {
// 							gotoNextQuestion();
// 						}}
// 					>
// 						Next
// 					</button>
// 				</div>
// 			</div>
// 		</div>
// 	</div>
// </div>
